"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PluginManagerBase_1 = require("auto-widget-framework/src/Plugin/PluginManagerBase");
class FormExtensionPluginProvider extends PluginManagerBase_1.default {
}
exports.default = FormExtensionPluginProvider;
